import {CollectBaseLineComponent} from './CollectBaseLineComponent';

export default CollectBaseLineComponent;
